<div class="inbuilt-filter">
    <div class="inbuilt-filter__header">
        <span class="inbuilt-filter__icon">
            <mat-icon aria-hidden="true">filter_alt</mat-icon>
        </span>
        <h2 class="inbuilt-filter__title">Add filters</h2>
    </div>
    <p class="inbuilt-filter__description">
        Define the scope for this page with time range, application, environment, or other dimensions.
    </p>
    <button type="button" class="inbuilt-filter__button" (click)="addFilter.emit()">
        <mat-icon aria-hidden="true">add</mat-icon>
        <span>Add filters</span>
    </button>
</div>
